var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHazardTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.448 7.20821V11.2082M11.448 15.2082H11.458M9.73802 2.06821L1.26802 16.2082C1.09339 16.5106 1.00099 16.8535 1.00001 17.2027C0.99903 17.552 1.08951 17.8953 1.26245 18.1987C1.43538 18.5021 1.68474 18.755 1.98573 18.9321C2.28671 19.1092 2.62882 19.2044 2.97802 19.2082H19.918C20.2672 19.2044 20.6093 19.1092 20.9103 18.9321C21.2113 18.755 21.4607 18.5021 21.6336 18.1987C21.8065 17.8953 21.897 17.552 21.896 17.2027C21.8951 16.8535 21.8027 16.5106 21.628 16.2082L13.158 2.06821C12.9797 1.77432 12.7287 1.53133 12.4292 1.3627C12.1297 1.19406 11.7918 1.10547 11.448 1.10547C11.1043 1.10547 10.7663 1.19406 10.4668 1.3627C10.1673 1.53133 9.91629 1.77432 9.73802 2.06821Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazardTriangle);
export default __webpack_public_path__ + "static/media/hazardTriangle.313f5c12e15695692012f996e81b2260.svg";
export { ForwardRef as ReactComponent };